<template>
  <v-card class="elevation-12 ma-4">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ $t("registration.title") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="100">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span><flag :iso="$i18n.locale.split('-')[1]" /></span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-toolbar-title>
        </template>
        <v-list>
          <v-list-item
            v-for="item in Object.keys(this.$i18n.messages)"
            :key="item"
            @click="$i18n.locale = item">
            <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card-text class="v-card__text">
      <v-alert :value="error" type="error" transition="scale-transition" >
        {{ $t("registration.error") }}
      </v-alert>
      <v-alert :value="finished" type="success" transition="scale-transition" >
        {{ $t("registration.registrationSuccessful") }}
      </v-alert>
      <v-form v-model="valid" v-if="!finished">
        <v-text-field name="firstName" :label="$t('profile.firstname')"
          type="text" v-model="user.FirstName" :rules="[rules.required]"></v-text-field>
        <v-text-field name="lastName" :label="$t('profile.lastname')" 
          type="text" v-model="user.LastName" :rules="[rules.required]"></v-text-field>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              :rules="[rules.required]"
              v-model="formattedDate"
              :label="$t('profile.dateofbirth')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker min="1919-01-01"
             v-model="dateofbirth" no-title @input="menu = false"
            :locale="$i18n.locale" first-day-of-week="1" ref="picker"></v-date-picker>
        </v-menu>
        <v-radio-group v-model="user.Gender" :rules="[rules.required]" row>
          {{ $t('profile.gender') }} &nbsp;
          <v-radio :label="$t('profile.male')" value="0"></v-radio>
          <v-radio :label="$t('profile.female')" value="1"></v-radio>
        </v-radio-group>
        <v-text-field name="email" :label="$t('profile.email')" 
          type="text" v-model="user.Email" :rules="[rules.required, rules.email]"></v-text-field>
        <v-text-field name="password" :label="$t('profile.password')" type="password" 
          v-model="user.Password" :rules="[rules.required, rules.passwordLength, rules.passwordNumerical]"></v-text-field>
        <v-text-field name="password" :label="$t('profile.repeatpassword')" type="password"
          v-model="user.ConfirmPassword" :rules="[rules.required, rules.passwordMatch]"></v-text-field>
        <v-checkbox color="red" v-model="submitTerms" :rules="[rules.required]"
                  :label="$t('application.submitTerms')"
                ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions class="v-card__actions" v-if="!finished">
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="!this.valid" @click="register">{{ $t("registration.title") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    VForm,
    VTextField,
    VDatePicker,
    VCard,
    VCardActions,
    VCardText,
    VRadioGroup,
    VRadio,
    VAlert,
    VMenu,
    VCheckbox,
    VListItem,
    VListItemTitle
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'fcc-registration',
    data: () => ({
      drawer: null,
      dateofbirth: "",
      user: {
        Email: "",
        Password: "",
        ConfirmPassword: ""
      },
      valid: false,
      finished: false,
      error: false,
      menu: false,
      submitTerms: false
    }),
    computed: {
      rules: function(){
        return {
          required: value =>  !!value || this.$t('registration.required'),
          email: value => {
            const pattern = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
            return pattern.test(value) || this.$t('registration.invalidEmail')
          },
          passwordMatch: value => value == this.user.Password || this.$t('registration.passwordMismatch'),
          passwordLength: value => value.length >= 6 || this.$t('registration.passwordLength'),
          passwordNumerical: value => {
            const pattern = /[0-9]/
            return pattern.test(value) || this.$t('registration.passwordNumerical')
          }
        }
      },
      formattedDate: function(){
        if(!this.dateofbirth) return "";
        var parts = this.dateofbirth.split('-');
        return parts[2]+"."+parts[1]+"."+parts[0];
      }
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    },
    methods:{
      register: function(){
        if(this.valid){
          this.user.Language = this.$i18n.locale;
          this.user.DateOfBirth = this.dateofbirth;
          fccapi.post(`register`, this.user).then(d => {
            console.log(d);
            this.finished = true;
          }).catch(e => {
            console.log(e);
            this.error = true;
          })
        }
      }
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VForm,
      VTextField,
      VDatePicker,
      VCardActions,
      VCardText,
      VRadioGroup,
      VRadio,
      VAlert,
      VMenu,
      VCheckbox,
      VListItem,
      VListItemTitle
    }
  }
</script>